import {
    NOTES_DELETE_OPEN_MODAL,
    NOTES_DELETE_REQUEST,
    NOTES_DELETE_RESULT
} from 'Redux/actionTypes';

export const notesDeleteRequest = (id) => ({
    type: NOTES_DELETE_REQUEST,
    payload: id
})

export const notesDeleteResult = (result) => ({
    type: NOTES_DELETE_RESULT,
    payload: result
})

export const notesDeleteOpenModal = (id) => ({
    type: NOTES_DELETE_OPEN_MODAL,
    payload: id
})